(function() { window.GUID_6731d285_cc2b_46c7_b98e_9329fe6473d3 = { getGuid: function() { return "6731d285-cc2b-46c7-b98e-9329fe6473d3"; } }; })();
var CompuSport;
(function (CompuSport) {
    var Controls;
    (function (Controls) {
        Controls.FormReadyArray = [];
        class Popup {
            constructor() {
                this.CallOnPostedWhenForceRefreshPopupContent = false;
                this.startPoint = { x: 0, y: 0 };
                this.startCornerPoint = { x: 0, y: 0 };
                this.enterKeyButtonValue = null;
                this.hasChangedList = [];
                this.bodyLeftOffset = CompuSport.DOM.body.offset().left;
            }
            static ShowConfirmDialogV2(title, message, callback) {
                var popup = new CompuSport.Controls.Popup();
                var content = "";
                if (message instanceof jQuery) {
                    content = "<div>" + message[0].outerHTML + "</div>";
                }
                else {
                    content = "<div>" + message + "</div>";
                }
                content += "<button class='PopupButtons' value='ok'>Ok</button>";
                content += "<button class='PopupButtons' value='cancel'>Cancel</button>";
                popup.Show(content, { PopupId: 'ConfirmDialog', Title: title });
                if (callback != null) {
                    popup.OnButtonClicked = function (clickedButton) {
                        if (clickedButton.val() == "ok") {
                            callback(popup);
                        }
                    };
                }
                return popup;
            }
            static ShowConfirmDialogWithResultV2(title, message, okText, cancelText, callback) {
                var popup = new CompuSport.Controls.Popup();
                var content = "";
                if (message instanceof jQuery) {
                    content = "<div>" + message[0].outerHTML + "</div>";
                }
                else {
                    content = "<div>" + message + "</div>";
                }
                content += "<button class='PopupButtons' value='ok'>" + okText + "</button>";
                content += "<button class='PopupButtons' value='cancel'>" + cancelText + "</button>";
                popup.Show(content, { PopupId: 'ConfirmDialog', Title: title });
                if (callback != null) {
                    popup.OnButtonClicked = function (clickedButton) {
                        callback(clickedButton.val() == "ok");
                    };
                }
                return popup;
            }
            static ShowInputDialogV2(message, memoStyle, callback, inputValue = null) {
                var popup = new CompuSport.Controls.Popup();
                var inputHtml = "";
                if (inputValue == null) {
                    inputValue = "";
                }
                if (memoStyle) {
                    inputHtml = "<textarea rows='10' style='margin-top:1em;width:300px;' class='CSDefault' id='InputDialogValue'>" + inputValue + "</textarea>";
                }
                else {
                    inputHtml = "<input style='margin-top:1em;width:300px;' class='CSDefault' id='InputDialogValue' type='text' value='" + inputValue + "' />";
                }
                var content = "<div style='max-width:350px;font-weight:bold;text-align:center;'>" + message + inputHtml + "</div>";
                content += "<button class='PopupButtons' value='ok'>Ok</button>";
                content += "<button class='PopupButtons' value='cancel'>Cancel</button>";
                popup.Show(content, { PopupId: 'ConfirmDialog' });
                if (callback != null) {
                    popup.OnButtonClicked = function (clickedButton) {
                        callback(popup.Content.find("#InputDialogValue").val(), clickedButton.val() == "ok");
                    };
                }
                return popup;
            }
            static ShowWarningDialog(message) {
                var popup = new CompuSport.Controls.Popup();
                var content = "";
                if (message instanceof jQuery) {
                    content = "<div>" + message[0].outerHTML + "</div>";
                }
                else {
                    content = "<div>" + message + "</div>";
                }
                content += "<button class='PopupButtons' value='ok'>Ok</button>";
                popup.Show(content, { PopupId: 'WarningDialog' });
                return popup;
            }
            GetAndShow(params) {
                let me = this;
                me.Params = params;
                if (me.AddToInstantiatedPopups() == false) {
                    return false;
                }
                if (params.Data == null) {
                    params.Data = {};
                }
                params.Data.isFromNewPopup = true;
                if (me.Params.DoNotAppendSportEventId == null || me.Params.DoNotAppendSportEventId == false) {
                    if (me.CSIsDefined() && CS.AddSportEventIdToUrl != undefined) {
                        me.Params.Url = CS.AddSportEventIdToUrl(me.Params.Url);
                    }
                }
                var urlQueryStringSeparator = "?";
                if (me.Params.Url.indexOf("?") > -1) {
                    urlQueryStringSeparator = "&";
                }
                var tickDate = Date.now().toString();
                //Ceci fait en sorte d'éviter que la popup tombe en cache
                me.Params.Url = me.Params.Url + urlQueryStringSeparator + "dummyDate=" + tickDate;
                if (me.OnShowing != null) {
                    me.OnShowing();
                }
                if (me.Params.AjaxCallType == CompuSport.Ajax.AjaxCallType.GET) {
                    CompuSport.Ajax.Get(me.Params.Url, me.Params.Data, function (response) {
                        me.Show(response, me.Params);
                    });
                }
                else {
                    CompuSport.Ajax.Post(me.Params.Url, me.Params.Data, function (response) {
                        me.Show(response, me.Params);
                    });
                }
            }
            Show(htmlContent, params) {
                var me = this;
                me.Params = params;
                if (params.AjaxCallType == null) {
                    if (me.AddToInstantiatedPopups() == false) {
                        return false;
                    }
                }
                //check if htmlContent is json
                if (typeof htmlContent === "object") {
                    if (me.OnPosted != null) {
                        me.OnPosted(htmlContent);
                    }
                    return;
                }
                if (me.Params.PopupId == null || me.Params.PopupId == "") {
                    var tickDate = Date.now();
                    me.Params.PopupId = "P" + tickDate.toString();
                }
                if (params.Buttons != null && params.Buttons != "") {
                    var splittedButtons = params.Buttons.split(',');
                    var end = splittedButtons.length;
                    for (var i = 0; i < end; i++) {
                        var button = splittedButtons[i];
                        htmlContent += '<button class="PopupButtons" value="' + button + '">' + button + '</button>';
                    }
                }
                me.Content = $('<div class="CSPopupContent">' + htmlContent + '</div>');
                me.Form = me.Content.find('form');
                me.Form.data("popupcontext", me);
                if (me.Form.length > 0) {
                    var idFromForm = me.Form[0].id;
                    if (idFromForm != "") {
                        me.Params.FormId = idFromForm;
                    }
                }
                if (me.Params.Title == null) {
                    var hiddenTitle = $('.PopupTitle', this.Content);
                    var header = $('header', this.Content).last();
                    if (hiddenTitle.length > 0) {
                        me.Params.Title = hiddenTitle.val();
                    }
                    else if (header.length > 0 && header.html().length > 0) {
                        me.Params.Title = header.html();
                    }
                    else {
                        if (me.Form.length > 0) {
                            me.Params.Title = me.Form[0].title;
                        }
                        else {
                            me.Params.Title = "";
                        }
                    }
                }
                var dialogStr = '<div class="CSPopupContainer">';
                {
                    dialogStr += '<div class="CSPopupOverlay"></div>';
                    dialogStr += '<div class="CSPopupContainerInside">';
                    {
                        dialogStr += '<div class="CSPopup" id="' + me.Params.PopupId + '">';
                        {
                            dialogStr += '<div class="CSPopupTitle">' + me.Params.Title + '</div>';
                            dialogStr += '<button class="CSPopupBtnXClose">X</button>';
                        }
                        dialogStr += '</div>';
                    }
                    dialogStr += '</div>';
                }
                dialogStr += '</div>';
                me.Container = $(dialogStr);
                me.InsideContainer = this.Container.find('.CSPopupContainerInside');
                me.Overlay = this.Container.find('.CSPopupOverlay');
                me.Popup = this.Container.find('.CSPopup');
                me.Popup.append(this.Content);
                me.Header = this.Popup.find(".CSPopupTitle");
                var btnXClose = me.Popup.find(".CSPopupBtnXClose");
                btnXClose.on('click', function (e) {
                    e.preventDefault();
                    me.ButtonClick(btnXClose);
                });
                me.links = me.Content.find('link');
                me.links.remove().appendTo(me.Container);
                CompuSport.DOM.body.append(this.Container);
                //(<any>$).validator.unobtrusive.parse(document);
                me.ForceFullScreen(me.Params.ForceFullScreen);
                var alreadyPositioning = false;
                setTimeout(function () {
                    CompuSport.trigger('popup.preslidedown', me);
                    alreadyPositioning = true;
                    me.CenterPopup(function () {
                        me.Popup.show(0, function () {
                            CompuSport.trigger('popup.slidedown', me);
                            me.FocusFirstTextBox();
                            me.DetectPopupOverflow();
                            alreadyPositioning = false;
                            me.Popup.isReady(() => {
                                me.CenterPopup();
                            });
                        });
                    });
                    me.Popup.resize(function () {
                        if (alreadyPositioning) {
                            return;
                        }
                        me.DetectPopupOverflow();
                        me.DetectPopupLimits();
                    });
                }, 250);
                CompuSport.DOM.win.on('resize.' + me.Params.PopupId, function () {
                    me.RefreshLayoutPositioning();
                    CompuSport.Lag(100, function () {
                        /*Besoin d'un 2e call puisque certaines valeur sont affecté sur le prmier call
                        et doit etre recalculé avec les nouvelles valeurs*/
                        me.RefreshLayoutPositioning();
                    });
                }).on('keydown.' + me.Params.PopupId, function (e) {
                    if (!me.IsLastInstantiatedPopup()) {
                        return;
                    }
                    if (e.which == 27) /*ESC key*/ {
                        if (!me.buttonsAreDisabled) {
                            if (me.OverrideCloseButton != null) {
                                me.OverrideCloseButton();
                            }
                            else {
                                me.Close();
                            }
                        }
                    }
                    else if (e.which == 13) /*Enter Key*/ {
                        if (me.Form.hasClass('DoNothingOnEnter')) {
                            return;
                        }
                        else if ($(e.target).hasClass('ui-autocomplete-input') || e.target.tagName == "TEXTAREA") {
                            return;
                        }
                        else if (e.target.tagName != "BUTTON") {
                            var buttons = me.ButtonsContainer.find('button');
                            $.each(buttons, function () {
                                if (me.enterKeyButtonValue == this) {
                                    me.ButtonClick($(this));
                                    e.preventDefault();
                                    return false;
                                }
                            });
                            e.preventDefault();
                            return false;
                        }
                    }
                }).on('mousemove.' + me.Params.PopupId, function (e) {
                    if (me.inMovement) {
                        var diffX = me.startPoint.x - e.clientX;
                        var diffY = me.startPoint.y - e.clientY;
                        var left = me.startCornerPoint.x - diffX;
                        var top = me.startCornerPoint.y - diffY;
                        if (left < 0) {
                            left = 0;
                        }
                        else if (left > me.popupLimits.Left) {
                            left = me.popupLimits.Left;
                        }
                        if (top < 0) {
                            top = 0;
                        }
                        else if (top > me.popupLimits.Top) {
                            top = me.popupLimits.Top;
                        }
                        me.SetPopupPosition(left, top);
                        me.DetectPopupOverflow();
                    }
                }).on('mouseup.' + me.Params.PopupId, function () {
                    me.inMovement = false;
                }).on('popstate.' + me.Params.PopupId, function (e) {
                    var lastPopup = me.GetLastInstantiatedPopup();
                    var state = e.originalEvent.state;
                    //si yen a pas, on return
                    if (!lastPopup || !lastPopup.Popup || lastPopup.Popup.length == 0) {
                        return;
                    }
                    // Si le state id est le popup courrant, ca veut dire qu'on vient de fermer le popup enfant
                    if (lastPopup.Popup[0].id != params.PopupId || (state != null && state.id == params.PopupId)) {
                        return;
                    }
                    me.Close(false);
                });
                //if (typeof (window.history.pushState) !== "undefined") {
                //    window.history.pushState({ id: params.PopupId }, params.Title, '#' + params.PopupId);
                //}
                me.PrepareControlsAndLayout();
                /*Patch, sinon, la popup apparait pas tout le temps, glitch en IE rare mais qui arrive*/
                me.Container.redraw();
                if (me.OnShowed != null) {
                    me.OnShowed();
                }
                me.CallOnContentLoaded();
                me.Header.on('mousedown', function (e) {
                    me.startPoint.x = e.clientX - me.InsideContainer.scrollLeft();
                    me.startPoint.y = e.clientY - me.InsideContainer.scrollTop();
                    var position = me.Popup.offset();
                    me.startCornerPoint.x = position.left;
                    me.startCornerPoint.y = position.top;
                    me.inMovement = true;
                });
                CompuSport.trigger('popup.shown', me);
            }
            RefreshLayoutPositioning() {
                let me = this;
                me.DetectPopupLimits();
                me.CalculateInsideContainerSize();
                me.CenterPopup();
                me.DetectPopupOverflow();
                me.DetectIfPopupReachRightLimit();
            }
            UpdateContent(htmlContent) {
                var me = this;
                me.Content.empty().append(htmlContent);
                me.Form = me.Content.find('form');
                if (me.Form.length > 0) {
                    var idFromForm = me.Form[0].id;
                    if (idFromForm != "") {
                        me.Params.FormId = idFromForm;
                    }
                }
                if (me.Params.Title == null) {
                    var hiddenTitle = $('.PopupTitle', this.Content);
                    if (hiddenTitle.length > 0) {
                        me.Params.Title = hiddenTitle.val();
                    }
                    else {
                        me.Params.Title = "";
                    }
                }
                me.PrepareControlsAndLayout();
                me.SetPopupPosition(this.popupPosition.Left, this.popupPosition.Top);
                me.DetectPopupOverflow();
                me.CallOnContentLoaded();
            }
            CallOnContentLoaded() {
                var me = this;
                if (me.Content != null) {
                    //Desabonne toutes les events
                    me.Content.off();
                }
                if (me.OnContentLoaded != null) {
                    me.OnContentLoaded();
                }
                if (typeof FreshworksWidget == 'function') {
                    FreshworksWidget('hide');
                }
                CompuSport.DOM.body.trigger('PopupContentLoaded', me);
            }
            IsLastInstantiatedPopup() {
                var lastPopup = this.GetLastInstantiatedPopup();
                if (lastPopup == this) {
                    return true;
                }
                else {
                    return false;
                }
            }
            GetLastInstantiatedPopup() {
                if (CompuSport.Controls.Popup.InstantiatedPopups != null && CompuSport.Controls.Popup.InstantiatedPopups.length > 0) {
                    var lastPopup = CompuSport.Controls.Popup.InstantiatedPopups[CompuSport.Controls.Popup.InstantiatedPopups.length - 1];
                    return lastPopup;
                }
                return null;
            }
            Close(fromCloseButton = true) {
                var me = this;
                if (me.Popup == null || me.Popup.length == 0) {
                    return;
                }
                if (typeof FreshworksWidget == 'function') {
                    FreshworksWidget('show');
                }
                var indexOfPopup = CompuSport.Controls.Popup.InstantiatedPopups.lastIndexOf(me);
                if (indexOfPopup > -1) {
                    CompuSport.Controls.Popup.InstantiatedPopups.splice(indexOfPopup, 1);
                }
                CompuSport.DOM.win
                    .off('resize.' + me.Params.PopupId)
                    .off('keydown.' + me.Params.PopupId)
                    .off('mousemove.' + me.Params.PopupId)
                    .off('mouseup.' + me.Params.PopupId)
                    .off('popstate.' + me.Params.PopupId);
                this.ButtonsContainer.off('click');
                if (me.OnClosing != null) {
                    me.OnClosing();
                }
                this.ButtonsContainer.slideUp(250, function () {
                    me.Popup.slideUp(250, function () {
                        me.Container.remove();
                        if (fromCloseButton) {
                        }
                        //window.history.go(-1);
                        if (me.OnClosed != null) {
                            me.OnClosed();
                        }
                    });
                });
                CompuSport.trigger('popup.closed', me);
            }
            FocusFirstTextBox() {
                var me = this;
                if (me.Params.DoNotFocusFirstInput != null && me.Params.DoNotFocusFirstInput) {
                    return;
                }
                var firstTextBox = $('input', me.Content).not('input[type=hidden]').first();
                if (firstTextBox.length == 0) {
                    firstTextBox = $('textarea', me.Content).first();
                }
                if (firstTextBox.length > 0 && !firstTextBox.hasClass('CSDatePicker')) {
                    firstTextBox.focus();
                }
                else {
                    var forceFocus = $('<a href="#" style="display:block;opacity:0;width:0;height:0;"></a>');
                    me.Content.append(forceFocus);
                    forceFocus.focus();
                }
                /*Marche pas bien en chrome, scroll toujours vers le button qui n'est pas toujours souhaitable*/
                //else {
                //    var firstButton = $('button', me.ButtonsContainer).first();
                //    if (firstButton.length > 0) {
                //        setTimeout(function () {
                //            var x = window.scrollX;
                //            var y = window.scrollY;
                //            firstButton.focus();
                //            window.scrollTo(x, y);
                //        }, 250);
                //    }
                //}
            }
            PrepareButtons() {
                var me = this;
                if (me.ButtonsContainer != null) {
                    me.ButtonsContainer.off('click');
                    me.ButtonsContainer.remove();
                }
                var popupButtons = this.Popup.find('.PopupButtons');
                var footer = this.Popup.find('footer');
                me.AllButtons = this.Popup.find('button:not(.KEP)');
                me.ButtonsContainer = $('<div class="CSPopupButtonsContainer"></div>');
                if (popupButtons.length == 0 && footer.length == 0) {
                    me.ButtonsContainer.css('height', 0);
                    me.ButtonsContainer.css('margin-top', 0);
                    me.Content.css('margin-bottom', 0);
                }
                let overFlowScrollIndicator = $('<div class="OverFlowScrollIndicator"><div class="ic-cs-chevron-down"></div></div>');
                let scrollToEndAnchor = $('<div class="scrollToEndAnchor"></div>');
                scrollToEndAnchor.insertAfter(me.Content);
                overFlowScrollIndicator.appendTo(me.ButtonsContainer);
                overFlowScrollIndicator.on('click', function () {
                    me.InsideContainer.scrollTo(scrollToEndAnchor, 1000);
                });
                popupButtons.remove().appendTo(me.ButtonsContainer);
                if (footer.length > 0) {
                    var buttons = footer.find('button');
                    $.each(buttons, function () {
                        let $this = $(this);
                        if ($this.val() != "cancel" && $this.val() != "nopost") {
                            $this.addClass('PostButton');
                        }
                    });
                    footer.remove().appendTo(me.ButtonsContainer);
                }
                me.Popup.append(me.ButtonsContainer);
                me.ButtonsContainer.on('click', 'button', function (e) {
                    e.preventDefault();
                    var button = $(e.target);
                    me.ButtonClick(button);
                });
                me.ButtonsContainer.show();
                CompuSport.DOM.doc.ajaxStart(function () {
                    me.DisableAllButtons();
                }).ajaxStop(function () {
                    me.EnableAllButtons();
                }).ajaxError(function (xhr, see, err) {
                    me.EnableAllButtons();
                });
                var button = me.ButtonsContainer.find('button');
                if (button.length > 0) {
                    var postButton = button.filter('.PostButton');
                    if (postButton.length > 0) {
                        me.enterKeyButtonValue = postButton[0];
                    }
                    else {
                        me.enterKeyButtonValue = button[0];
                    }
                }
            }
            DisableAllButtons() {
                var me = this;
                me.buttonsAreDisabled = true;
                me.AllButtons.attr('disabled', 'disabled');
            }
            EnableAllButtons() {
                var me = this;
                me.buttonsAreDisabled = false;
                me.AllButtons.removeAttr('disabled');
            }
            ButtonClick(button) {
                console.log("popup click done");
                var me = this;
                if (button.hasClass('PostButton')) {
                    if (me.OnButtonClicked != null) {
                        me.OnButtonClicked(button, button.val());
                    }
                    me.PostForm(button);
                }
                else {
                    if (!button.hasClass('DoNotCloseOnClick')) {
                        if (me.OverrideCloseButton != null) {
                            me.OverrideCloseButton();
                        }
                        else {
                            me.Close();
                        }
                    }
                }
                if (!button.hasClass('PostButton') && me.OnButtonClicked != null) {
                    me.OnButtonClicked(button, button.val());
                }
                CompuSport.DOM.body.trigger('PopupButtonClick', me);
            }
            CenterPopup(callback) {
                var me = this;
                me.CalculatePopupSize();
                var windowWidthOverflow;
                var windowHeightOverflow;
                var patch = 20; /*Evite un padding a gauche etrange de temps en temps lorsque presque full screen. Evidamment, c'Est une merde de faire ca dememe mais pour l'instant, ca depanne :) */
                windowWidthOverflow = me.popupSize.Width + patch >= this.containerSize.Width;
                windowHeightOverflow = me.popupSize.Height + patch >= this.containerSize.Height;
                var left = windowWidthOverflow ? 0 : (this.containerSize.Width / 2 - me.popupSize.Width / 2);
                var top = windowHeightOverflow ? 0 : (this.containerSize.Height / 2 - me.popupSize.Height / 2);
                /*les grosses popup, ca fait chier quand ca ouvre centré. apres ca les drop down marche mal.*/
                /*laisse le login centré. c'est surtout pour les form avec des accordions et des drop downs.*/
                if (me.popupSize.Height >= 350 && me.Params.FormId != 'Login') {
                    top = 15;
                }
                me.SetPopupPosition(left, top);
                if (callback != undefined) {
                    callback.call(this);
                }
            }
            CalculateInsideContainerSize() {
                this.containerSize = new CompuSport.Layout.Size(this.InsideContainer.outerWidth() + 1, this.InsideContainer.outerHeight() + 1);
            }
            CalculatePopupSize() {
                this.popupSize = new CompuSport.Layout.Size(this.Popup.outerWidth(), this.Popup.outerHeight());
            }
            SetPopupPosition(left, top) {
                if (left < 0) {
                    left = 0;
                }
                if (top < 0) {
                    top = 0;
                }
                this.popupPosition = new CompuSport.Layout.Position(left, top);
                this.Popup.css("top", top + "px");
                this.Popup.css("left", left + 'px');
                let buttonsLeft = left + this.bodyLeftOffset;
                this.ButtonsContainer.css("left", buttonsLeft + "px");
                if (this.OnPopupPositioned != null) {
                    this.OnPopupPositioned();
                }
            }
            DetectPopupOverflow() {
                this.CalculatePopupSize();
                var bottom = this.popupSize.Height + this.popupPosition.Top;
                var right = this.popupSize.Width + this.popupPosition.Left;
                if (bottom > this.containerSize.Height) {
                    this.Container.addClass('OverflowHeight');
                }
                else {
                    this.Container.removeClass('OverflowHeight');
                }
                let windowWidthOverflow = false;
                if (right > this.containerSize.Width) {
                    this.Container.addClass('OverflowWidth');
                    windowWidthOverflow = true;
                }
                else {
                    this.Container.removeClass('OverflowWidth');
                    windowWidthOverflow = false;
                }
                var width = windowWidthOverflow ? this.containerSize.Width : this.popupSize.Width;
                if (this.Container.hasClass('OverflowHeight') && !this.Container.hasClass('OverflowWidth')) {
                    this.ButtonsContainer.css('width', width + 'px');
                }
                else {
                    this.ButtonsContainer.css('width', 'inherit');
                }
            }
            DetectIfPopupReachRightLimit() {
                if (this.popupPosition.Left > this.popupLimits.Left) {
                    this.SetPopupPosition(this.popupLimits.Left, this.popupPosition.Top);
                }
            }
            DetectPopupLimits() {
                this.popupLimits = new CompuSport.Layout.Position(0, 0);
                const rightMargin = 30; /*Claire la scrollbar*/
                const bottomMargin = 5;
                const overflowIndicator = 15;
                this.popupLimits.Left = this.Overlay.innerWidth() - this.popupSize.Width - rightMargin;
                this.popupLimits.Top = this.Overlay.innerHeight() - (this.Header.outerHeight() + this.ButtonsContainer.outerHeight() + bottomMargin + overflowIndicator);
            }
            AddToInstantiatedPopups() {
                var me = this;
                if (CompuSport.Controls.Popup.InstantiatedPopups == null) {
                    CompuSport.Controls.Popup.InstantiatedPopups = new Array();
                }
                var length = CompuSport.Controls.Popup.InstantiatedPopups.length;
                for (var i = 0; i < length; i++) {
                    var popup = CompuSport.Controls.Popup.InstantiatedPopups[i];
                    if (popup.Params.PopupId == me.Params.PopupId) {
                        return false;
                    }
                }
                CompuSport.Controls.Popup.InstantiatedPopups.push(this);
                return true;
            }
            BindTrackChanges() {
                var me = this;
                function handleChange(e, element) {
                    var csInput = $(e.target).closest('.CSInput');
                    if (csInput.data('trackchanges') == "False") {
                        return;
                    }
                    csInput.addClass('IsEdited');
                    me.AddClassParentAccordion(me.Popup, csInput, 'IsEdited', false);
                    var multiEditCheckBox = $('.MultiEditCheckBox', csInput);
                    multiEditCheckBox.off('change');
                    multiEditCheckBox.on('change', function () {
                        if (this.checked == false) {
                            csInput.removeClass('IsEdited');
                        }
                        else {
                            csInput.addClass('IsEdited');
                        }
                        me.AddClassParentAccordion(me.Popup, csInput, 'IsEdited', false);
                    });
                    //Si je fais 
                    var fgTweek = $('.FGTweek', csInput);
                    if (fgTweek != null && fgTweek.length > 0) {
                        fgTweek.val("true,false");
                    }
                    multiEditCheckBox.prop('checked', true);
                    multiEditCheckBox.trigger('change');
                }
                me.Popup.on('CSChange', handleChange);
                me.Popup.find('.CSDropDown').on('change', handleChange); //Il faut specifier CSDropDown pour eviter le clash avec le change du multiEditCheckBox
            }
            PostForm(postButton) {
                var me = this;
                this.CurrentPostButton = postButton;
                var form = me.Content.find('form');
                var event = $.Event('postform');
                form.trigger(event);
                if (event.isDefaultPrevented()) {
                    return;
                }
                if (me.AlreadyPosted) {
                    return;
                }
                me.AlreadyPosted = true;
                var url = me.Popup.find('form').attr('action');
                if (me.CSIsDefined() && CS.AddSportEventIdToUrl != undefined) {
                    url = CS.AddSportEventIdToUrl(url);
                }
                var separator = "&";
                if (url.indexOf("&") == -1) {
                    separator = "?";
                }
                form.find("#PopupClickedButton").remove();
                if (typeof (postButton) !== "undefined") {
                    var hiddenCopyOfButtonText = "<input id='PopupClickedButtonText' name='popupClickedButtonText' type='hidden' value='" + postButton.html() + "'/>";
                    form.append(hiddenCopyOfButtonText);
                    var hiddenCopyOfButton = "<input id='PopupClickedButton' name='popupClickedButton' type='hidden' value='" + postButton.val() + "'/>";
                    form.append(hiddenCopyOfButton);
                }
                CompuSport.Send.AppendHasChangedElementsToForm(form);
                var formData = form.first().serialize();
                var editedInputs = me.Content.find('form .IsEdited input');
                CompuSport.Ajax.Post(url, formData, function (response) {
                    me.AlreadyPosted = false;
                    var $response = $('<div>' + response + '</div>');
                    var mayClosePopup = true;
                    if ($response.find('.validation-summary-errors').length > 0) {
                        me.UpdateContent(response);
                    }
                    else {
                        var forceRefreshPopupContent = $response.find("#ForceRefreshPopupContent");
                        if (forceRefreshPopupContent.length > 0) {
                            //Entre ici lorsque la Popup est refreshed avec le warning
                            me.UpdateContent(response);
                            $.each(editedInputs, function (index, value) {
                                var label = $('form').find('[name="' + $(value).attr('name') + '"]');
                                var csInput = label.closest('.CSInput, .InputRow');
                                csInput.addClass('IsEdited');
                                //on va chercher le meme control que celui dans SendHelper.ts
                                var control = csInput.find('.IHasChanged').data('context');
                                //clear la StartValue so that the control HasChanged == true
                                if (control != undefined)
                                    control.ClearStartValue();
                            });
                            mayClosePopup = false;
                            var errors = $response.find('.CSValidationSummaryErrors');
                            if (errors.length > 0 && me.OnPostedValidationErrors != null) {
                                var jsonDatas = $response.find("#JsonDatas");
                                var result;
                                if (jsonDatas.length > 0) {
                                    result = jsonDatas.data('jsondatas');
                                }
                                me.OnPostedValidationErrors(result);
                            }
                            //me.FocusFirstTextBox();
                            //if (me.CallOnPostedWhenForceRefreshPopupContent) {
                            //    if (me.OnPosted != null) {
                            //        me.OnPosted(response);
                            //    }
                            //}
                            //me.DoAfterPost(response, false);
                        } //else {
                        //if (me.OnPosted != null) {
                        //    me.OnPosted(response);
                        //}
                        //if (postButton != null && !postButton.hasClass('DoNotCloseOnClick')) {
                        //if (me.OverrideCloseButton != null) {
                        //    me.OverrideCloseButton();
                        //}
                        //else {
                        //    me.Close();
                        //}
                        //}
                        //}
                        me.DoAfterPost(response, mayClosePopup);
                    }
                }, function () {
                    me.AlreadyPosted = false;
                });
            }
            DoAfterPost(response, mayClose) {
                console.log("done after post");
                var me = this;
                if (me.OnPosted != null && (me.CallOnPostedWhenForceRefreshPopupContent || mayClose)) {
                    me.OnPosted(response);
                }
                if (this.CurrentPostButton != null && !this.CurrentPostButton.hasClass('DoNotCloseOnClick') && mayClose) {
                    if (me.OverrideCloseButton != null) {
                        me.OverrideCloseButton();
                    }
                    else {
                        me.Close();
                    }
                }
            }
            PrepareControlsAndLayout() {
                var me = this;
                var header = $('header', this.Content).last();
                if (header.length > 0) {
                    header.remove();
                }
                $(".CSAccordion", me.Container).accordion({
                    heightStyle: "content",
                    activate: function () {
                        me.CalculateInsideContainerSize();
                        me.CalculatePopupSize();
                        me.DetectPopupLimits();
                    }
                });
                me.PrepareButtons();
                me.BindTrackChanges();
                me.CalculateInsideContainerSize();
                me.CalculatePopupSize();
                me.DetectPopupLimits();
                var csValidationSummaryErrors = $('.CSValidationSummaryErrors', me.Container);
                if (csValidationSummaryErrors.length > 0) {
                    var errorsElements = $('.ErrorMessage', me.Container);
                    me.AddClassParentAccordion(me.Container, errorsElements, 'AccordionError', true);
                }
                if (this.CSIsDefined() && CS.RefreshBehaviorOfScript != undefined) {
                    CS.RefreshBehaviorOfScript(me.Popup);
                }
                if (Controls.FormReadyArray != null && Controls.FormReadyArray.length > 0) {
                    $.each(Controls.FormReadyArray, function (index, delegate) {
                        delegate.call(me.Popup, me.Params.FormId);
                    });
                }
            }
            CSIsDefined() {
                return typeof (CS) != "undefined";
            }
            ForceFullScreen(fullScreen) {
                if (fullScreen) {
                    var windowW = CompuSport.DOM.win.width();
                    var windowH = CompuSport.DOM.win.height();
                    //view full screen mode
                    var wFull = windowW - 50;
                    var hFull = windowH - 95;
                    this.Content.css('width', (wFull - this.Content.outerWidth(true)) + "px");
                    this.Content.css('height', (hFull - this.Content.outerHeight(true)) + "px");
                }
            }
            AddClassParentAccordion(container, elementsInAccordion, classNames, scrollToFirstCorrespondingHeader) {
                var parentAccordions = elementsInAccordion.closest('.ui-accordion-content');
                var firstHeader = null;
                $.each(parentAccordions, function () {
                    var actualHeader = container.find('[aria-controls =' + this.id + ']');
                    actualHeader.addClass(classNames);
                    if (firstHeader == null && actualHeader.length > 0) {
                        firstHeader = actualHeader;
                    }
                });
                if (firstHeader != null && scrollToFirstCorrespondingHeader) {
                    scrollTo(null, firstHeader.offset().top);
                }
                firstHeader = null;
            }
        }
        Controls.Popup = Popup;
    })(Controls = CompuSport.Controls || (CompuSport.Controls = {}));
})(CompuSport || (CompuSport = {}));

//# sourceMappingURL=Popup.js.map
